import React from 'react';
import './Sidebar.css';

const Sidebar = ({ children, isMobileOpen = false }) => {
  return (
    <div className={`sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
      {children}
    </div>
  );
};

export default Sidebar;

